<template>
  <view class="main">
    <view class="content-item">
      <JourneySite
        wx:style="width: 100%"
        selectCityList="{{ selectCityList }}"
        bind:exchange="exchange"
        bind:click="goPage"
      />
    </view>
    <view class="content-item content-item-train-date" catchtap="onTravelCalendarShow">
      <view class="content-item-date">
        {{ selectDateText1 }}
      </view>
      <view class="content-item-week">
        {{ selectDateText2 }}
      </view>
    </view>
    <es-checkbox-group
      wx:model="{{checkboxValue}}"
      direction="row"
      wx:style="justify-content:space-between;"
    >
      <es-checkbox
        class="content-checkbox"
        wx:for="{{condition}}"
        wx:key="{{item.value}}"
        name="{{item.value}}"
        label-position="right"
        nameIcon="check-filled"
        shap="square"
        iconSize="{{12}}"
        fontSize="{{18}}"
        icon-style="{{{borderRadius: '4px', height: '12px', width: '12px'}}}"
        bindchange="onChange(item.value)"
      >
        <text class="es-rm-checkbox">{{ item.name }}</text>
      </es-checkbox>
    </es-checkbox-group>
     <view class="es-rm-rule" bindtap="notice" wx:if="{{checkboxValue.includes('student')}}">学生购票须知</view>
    <view class="card-button-area" bindtap="search">
      <view class="card-button" wx:style="{{btnStyle}}">查询车票</view>
      <BubbleBtn class="bubble-btn" bubbleText="{{bubbleText}}" />
    </view>
    <SearchHistory wx:if="{{!isAliAndNotLogin}}" historyList="{{ historyList }}" />
  </view>
  <es-popup wx:model="{{ travelCalendarVisible }}" position="bottom" closeable="{{true}}">
    <es-calendar
      ref="calendar"
      type="single"
      showConfirm="{{false}}"
      wx:model="{{selectDateValue}}"
      maxDate="{{limitDate.maxDateForReserve}}"
      minDate="{{limitDate.minDate}}"
      bindconfirm="onConfirm"
    />
  </es-popup>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import store from '@/store'
  import { isFastDoubleClick } from '@/utils/double-click'
  import { trackEvent } from '@/common/track'
  import Toast from '@didi/es-mpx-ui/lib/toast/functional'
  import { getStorage, setStorage } from '@/utils/storage'
  import {
    HOME_SEARCH_CONDITION,
    HOME_SELECTED_DATE,
    STORAGE_LIST_SEARCH_QUERY,
    STORAGE_CURRENT_SELECTED_CITY,
    STORAGE_ORIGINAL_LIST_SEARCH_QUERY,
    STORATE_CONDITION_SEARCH_QUERY,
  } from '@/utils/train-storage'
  import {
    parseDate,
    compare,
    getFullDate,
    formatDate,
  } from '@didi/es-mpx-shared'
  import usexStore from '@/config/usex/lib/store'
  import { addRavenPhoneAndUid } from '@/common/raven-init/init'
  import { innerRouter, pagePath } from '@/common/jump'
  import dayjs from 'dayjs'
  import { query, is } from '@didi/webx-js'

  createComponent({
    props: {
    },
    data: {
      checkboxValue: getStorage(HOME_SEARCH_CONDITION) || [],
      condition: [
        { value: 'student', name: '学生票', checked: false },
        { value: 'only_high', name: '只看高铁/动车', checked: false }
      ],
      selectDateText1: '',
      selectDateText2: '',
      selectDateValue: [],
      travelCalendarVisible: false,
    },
    ready() {
      const trainFromDate = query().train_from_date ?? ''
      trainFromDate && this.setSelectDate(dayjs(trainFromDate)?.valueOf() ?? dayjs().valueOf())
    },
    computed: {
      ...store.mapState({
        historyList: 'travel.historyList',
        homePageData: 'common.homePageData',
        homeApolloData: 'common.homeApolloData',
        token: 'user.token',
        userInfo: 'user.userInfo',
        travel: 'travel.travel',
      }),
      ...store.mapGetters({
        selectCityList: 'travel.selectCityList',
        selectDate: 'travel.selectDate',
        limitDate: 'change.limitDate',
        travelInfo: 'travel.travelInfo',
        isAliAndNotLogin: 'user.isAliAndNotLogin'
      }),
      bubbleText() {
        return this.homePageData?.discount_desc
      },
      isLogin() {
        return this.token || this.userInfo?.token
      },
      btnStyle() {
        return {
          background: this.homeApolloData?.btn?.backgroundColor || "#f2f6f9"
        }
      },
    },
    watch: {
      limitDate: {
        deep: true,
        handler() {
          const { start_date, end_date } = this.travelInfo || {}
          if (!start_date || !end_date) return
          let compareDate = Date.now()
          const compareResult3 = compare(compareDate, start_date)
          const compareResult4 = compare(end_date, compareDate)
          const itsTime2 =
            (compareResult3 === 0 || compareResult3 === 1) &&
            (compareResult4 === 0 || compareResult4 === 1)
          // itsTime2 为true代表着compareDate处在开始时间与截止时间之间，展示使用compareDate；为false代表着compareDate不在时间区间内，直接取用开始时间
          if (itsTime2) {
            this.setTravelDate(compareDate)
          } else {
            const start = parseDate(start_date)?.getTime?.()
            this.setTravelDate(start)
          }
        },
      },
      selectDate: {
        immediate: true,
        handler() {
          this.selectDate && this.setSelectDate(this.selectDate)
        }
      },
      checkboxValue: {
        handler() {
          setStorage({ key: HOME_SEARCH_CONDITION, data: this.checkboxValue })
        }
      }
    },
    methods: {
      ...store.mapMutations({
        setHistoryList: 'travel.setHistoryList',
        setTravelDate: 'travel.setTravelDate',
        setTravelDate: 'travel.setTravelDate',
        changeSelectCityList: 'travel.changeSelectCityList',
      }),
      exchange() {
        const [currentFromCity, currentToCity] = this.selectCityList
        this.changeSelectCityList({
          type: 'currentFromCity',
          data: currentToCity
        })
        this.changeSelectCityList({
          type: 'currentToCity',
          data: currentFromCity
        })
      },
      setSelectDate(time) {
        this.setTravelDate(time)
        const zeroTime = (time) => (time > 9 ? time : '0' + time)
        const selectTime = getFullDate(time)
        this.selectDateText1 = `${zeroTime(selectTime.month)}月${zeroTime(selectTime.day)}日`
        this.selectDateText2 = `周${selectTime.weekName}`
        this.selectDateValue = [time]     
      },
      onTravelCalendarShow() {
        trackEvent('userteam_train_home_tickets_ck', 'UT-火车票-首页-票模块-点击', { module: 'date' })
        this.travelCalendarVisible = true
      },
      onTravelCalendarClose() {
        this.travelCalendarVisible = false
      },
      onConfirm({ detail: [time] }) {
        this.setSelectDate(time)
        setStorage({key:HOME_SELECTED_DATE, data: time})
        this.onTravelCalendarClose()
      },
      onChange(module) {
        trackEvent('userteam_train_home_tickets_ck', 'UT-火车票-首页-票模块-点击', { module })
      },
      search() {
        if (isFastDoubleClick()) return
        trackEvent('userteam_train_home_tickets_ck', 'UT-火车票-首页-票模块-点击', {
          module: 'search'
        })
        const selectCityList = this.selectCityList
        if (!selectCityList?.[0]?.id || !selectCityList?.[1]?.id) {
          Toast({
            message: '请选择出发地与目的地',
            overlay: false
          })
          return
        }
        this.setHistoryList(JSON.parse(JSON.stringify(selectCityList)))
        if (!this.selectDate) return
        this.saveDataAndPushListPage()
      },
      saveDataAndPushListPage() {
        const { selectDate, selectCityList, checkboxValue } = this
        const travel_type = []
        const query = {
          train_date: formatDate(selectDate, 'YYYY-MM-dd'),
          from_station_name: selectCityList?.[0].name,
          to_station_name: selectCityList?.[1].name,
          from_city_match: '',
          to_city_match: '',
          train_type_code: checkboxValue.includes('only_high') ? 'G,C,D' : '',
          start_time_list: JSON.stringify([]),
          end_time_list: JSON.stringify([]),
          order_by_start_time: '0',
          is_fxh: '0',
          is_zndc: '0',
          is_quiet: '0',
          order_by: 'start',
          order_rules: 'asc',
          preferred_tickets: '0',
          from_prefect_match: 0,
          to_prefect_match: 0,
          passenger_type: checkboxValue.includes('student') ? 13 : 11
        }
        const scrambleQuery = {
          train_date: formatDate(selectDate, 'YYYY-MM-dd'),
          from_station_name: selectCityList?.[0].name,
          to_station_name: selectCityList?.[1].name,
          from_city_match: '',
          to_city_match: '',
          train_type_code: '',
          start_time_list: JSON.stringify([]),
          end_time_list: JSON.stringify([]),
          order_by_start_time: '0',
          is_fxh: '0',
          is_zndc: '0',
          is_quiet: '0',
          order_by: 'start',
          order_rules: 'asc',
          preferred_tickets: '0',
          from_prefect_match: 0,
          to_prefect_match: 0,
          passenger_type: checkboxValue.includes('student') ? 13 : 11
        }
        setStorage({ key: STORAGE_CURRENT_SELECTED_CITY, data: selectCityList })
        setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: query })
        setStorage({ key: STORAGE_ORIGINAL_LIST_SEARCH_QUERY, data: scrambleQuery })
        setStorage({ key: STORATE_CONDITION_SEARCH_QUERY, data: {} })
        // 勾选了高铁动车和学生票筛选后，把筛选条件带到列表页
        const _condition = {
          train_type_code: checkboxValue.includes('only_high') ? ['G','C','D'] : [],
          passenger_type: checkboxValue.includes('student') ? '13' : '11',
          start_time_list: [],
          end_time_list: [],
          from_city_match: [],
          to_city_match: []
        }
        setStorage({
          key: STORATE_CONDITION_SEARCH_QUERY,
          data: _condition
        })
        this.goPage()
      },
      goPage() {
        //如果没有登陆 那么吊起登陆  整改需求
        if (!this.isLogin && !is('alipay')) {
          usexStore.dispatch('getToken', true).then((res) => {
            addRavenPhoneAndUid(res)
          })
          return
        }
        innerRouter.push(pagePath().SEARCHLIST, {
          from: 'home'
        })
      },
      notice() {
        innerRouter.push(pagePath().ICKETPURCHASENOTICE, {
          checkTabIndex: 'student'
        })
      }
    }
  })
</script>

<style lang='stylus' scoped>
@import '~@/mixins/stylus/color.styl'

.main
  background #fff
  border-radius 16px
  overflow hidden
  padding 0 16px 16px
  .content-item
    display flex
    justify-content space-between
    align-items center
    height 66px
    width 100%
    font-size 16px
    color $train-color-333
    border-bottom 0.5px solid $train-color-eee
  .content-item-train-date
    line-height 53px
    justify-content flex-start
    height 53px
    align-items baseline
    .content-item-date
      font-weight 600
      font-size 18px
      font-family PingFangSC-Regular, Helvetica, Arial, sans-serif
    .content-item-week
      font-weight 500
      font-size 13px
      margin-left 4px
  .content-checkbox
    height 47px
    display flex
    align-items center
    user-select none
    overflow hidden
    .es-checkbox .es-checkbox__icon
      border-radius 4px !important
  .es-rm-checkbox
    font-weight 400
    font-size 13px
    color $train-color-666
    margin-left -4px
  .es-rm-rule
    font-size 11px
    color #FF6400
    margin-left 6px
    position relative
    top -31px
    left 55px
    height 0
  .card-button-area
    position relative
    .card-button
      height 50px
      line-height 50px
      font-size 16px
      text-align center
      color white
      border-width 0px
      border-radius 12px
      font-weight 600
    .bubble-btn
      position absolute
      top -10px
      right 0
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'JourneySite': '../journey-site',
      'SearchHistory': '../search-history',
      'BubbleBtn': '../bubble-btn',
      'es-checkbox-group': '@/es-mpx-ui/lib/checkbox-group',
      'es-checkbox': '@/es-mpx-ui/lib/checkbox',
      'es-calendar': '@/components/calendar',
    }
  }
</script>
